<template>
  <b-modal ref="skillmapModal" hide-footer title="Choose Skillset" centered scrollable lazy size="lg" @hide="hideModal">
    <div v-if="isLoading" class="skillset-loading">
      <i class="fas fa-circle-notch fa-spin" style="font-size: 25px;"></i>
    </div>
    <div v-else>
      <div class="skillset-modal">
        <div class="skillset-list">
          <div v-if="skills.length == 0">
            <p class="text-70 ml-1 mb-4 italic empty-skillset">No skillsets to display.</p>
          </div>
          <div v-else>
            <p class="text-70 ml-1 mb-4">Select a skillset to practice with flashcards</p>
            <div v-for="skill in skills" :key="skill.title" class="skillset-item" @click="selectSkill(skill)" :class="{'clickable-item-hov':  skill.card_count > 0}">
              <div class="skill-icon">
                <div class="placeholder-icon"></div>
              </div>
              <div class="skill-content">
                <h3>{{ skill.title }}</h3>
                <p class="skill-description">
                  {{ skill.description ? skill.description : `Practice with ${skill.title} skill from the program` }}
                </p>
                <div class="skill-meta">
                  <span>{{ skill.card_count }} cards</span>
                  <span
                    :style="{
                      marginLeft: isMobileScreen ? '6px' : '12px',
                      marginRight: isMobileScreen ? '6px' : '12px',
                    }"
                    >•</span
                  >
                  <span>~{{ skill.duration }} min</span>
                </div>
              </div>
              <div class="arrow" :style="{ backgroundColor: skillButtonBgColor(skill.card_count) }">
                <md-icon>chevron_right</md-icon>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'FlashcardModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      skills: [],
      modalTitle: 'Select Skillset',
      isLoading: false,
      windowWidth: window.innerWidth,
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.$refs.skillmapModal.show();
        this.fetchSkillsetList();
      } else {
        this.$refs.skillmapModal.hide();
      }
    },
  },
  computed: {
    ...mapGetters('auth', ['getLoggedInUser']),
    isMobileScreen() {
      return this.windowWidth <= 420;
    },
  },
  methods: {
    ...mapActions('aiSkills', ['getSkillsetList']),
    selectSkill(skill) {
      if(skill.card_count > 0){
      this.$router.push({
        name: 'student-flashcard',
        query: { skillmap: skill.id ? skill.id : 'all' },
      });
    }
    },

    hideModal() {
      //this.$refs.skillmapModal.hide();
      this.$emit('hide-flashcard-modal');
    },
    skillButtonBgColor(count) {
      return count > 0 ?  this.getLoggedInUser.linked_entity.primary_color : 'rgb(183 183 183)' 
    },
    async fetchSkillsetList() {
      try {
        this.isLoading = true;
        const resp = await this.getSkillsetList();
        this.skills = resp.data;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        return;
      }
    },
  },
};
</script>

<style scoped>
.skillset-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.skillset-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border: 1px solid #eee;
  border-radius: 8px;
  transition: all 0.2s ease;
  margin-bottom: 5px;
}

.skillset-item:hover {
  background: #f8f9fa;
  border-color: #ddd;
}

.skill-icon {
  width: 48px;
  height: 48px;
  background: #f0f0f0;
  margin-right: 16px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.placeholder-icon {
  background-color: #b7b7b7;
  width: 24px;
  height: 24px;
  margin: 5px;
  border-radius: 6px;
}

.skill-content {
  flex: 1;
}

.skill-content h3 {
  margin: 0 0 4px;
  font-size: 16px;
}

.skill-description {
  margin: 0 0 8px;
  color: #666;
  font-size: 14px;
}

.skill-meta {
  font-size: 14px;
  color: #888;
}

.arrow {
  color: white;
  border-radius: 100%;
  padding: 5px;
}
.skillset-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100px;
}
.empty-skillset {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  font-size: large;
  font-style: italic;
}
</style>
